import {BlockSelector, ESD_BLOCK_BUTTON} from '../../constants/BlockName';
import {ImmutableHtmlNode} from '../../modifications/ImmutableNode';
import {BuiltInControl} from '../BuiltInControl';

export abstract class ButtonBuiltInControl extends BuiltInControl {
  public getTargetNodes(root: ImmutableHtmlNode): ImmutableHtmlNode[] {
    const buttons = root.querySelectorAll(BlockSelector.BUTTON);
    const button = root.asElement().hasClass(ESD_BLOCK_BUTTON) ? [root] : [];
    return buttons.length ? buttons : button;
  };
}
